// extracted by mini-css-extract-plugin
export default {"details":"style_details__UTrrG","table":"style_table__7SfNp","smallTable":"style_smallTable__-Xl9D","broad":"style_broad__yXUSC","body":"style_body__ORTZU"};